import script from "./ResponseStatsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ResponseStatsModal.vue?vue&type=script&setup=true&lang=js"

import "./ResponseStatsModal.vue?vue&type=style&index=0&id=5c082498&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c082498"]])

export default __exports__